import React from 'react';
import { motion } from 'framer-motion';
export function OurStory() {
  return <section className="bg-white py-24 md:py-32 px-6" data-id="element-250">
      <div className="max-w-7xl mx-auto" data-id="element-251">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 md:mb-20" data-id="element-252">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-253">
            Since 2004
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-8" data-id="element-254">
            Our Beginning
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-10" data-id="element-255" />

          <p className="text-[#86868b] text-[20px] md:text-[24px] leading-[1.6] font-light max-w-4xl mx-auto first-letter:text-5xl first-letter:font-display first-letter:text-[#c9a961] first-letter:mr-2 first-letter:float-left" data-id="element-256">
            BV Hospitality Group is a consortium of authentic Indian fine dining
            restaurants and an Indian lounge and bar in prime markets like
            Pratunum and Sukhumvit Soi 11 in Bangkok as well as Sri Racha and
            the Pattaya Floating Market, with more flagship restaurants joining
            soon. It was established in 2004 with the aim to make Indian food
            easily available in Thailand for tourists, the local Indian
            fraternity, and all those who love Indian food. Today, BV Group
            Hospitality encompasses a growing portfolio of unique businesses,
            each with its own character and specialty, united by our core values
            of culinary excellence, cultural authenticity, and guest
            satisfaction.
          </p>
        </motion.div>
      </div>
    </section>;
}